function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var svg = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiI+PHBhdGggZD0iTTQgMjRoMjR2LTIuNjY3SDRWMjR6bTAtNi42NjdoMjR2LTIuNjY2SDR2Mi42NjZ6TTQgOHYyLjY2N2gyNFY4SDR6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiMwMjE4MjgiLz48L3N2Zz4=";
import { SvgIcon } from "./SvgIcon";
export var IconMenu = function IconMenu(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    src: svg,
    testId: "icon-menu"
  }));
};